import React from 'react'
import img1 from '../images/common.webp'
import Ready from './Ready'
import Testimonial from './Testimonial'
import { useMediaQuery } from 'react-responsive'

const CommonBackground = ({ child }) => {
  const isMobile = useMediaQuery({ query: '(max-width: 991px)' });
  return (
    <div
      className="common-background position-relative"
      style={{
        height: "100dvh",
        overflow: "hidden",
      }}
    >
      <img
        src={isMobile ? "readymbg.png" : "readybg.png"}
        alt="background"
        className="position-absolute top-0 start-0 w-100 h-100"
        style={{
          objectFit: "cover",
        }}
      />

      {
        child === 'ready'
          ? <Ready />
          : <Testimonial />
      }
    </div>
  )
}

export default CommonBackground
